import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_LETTER_TEMPLATES',
    icon: 'BookIcon',
    route: 'letters',
    action: constants.action.permissionLettersList,
    resource: constants.resource.letterTemplate,
  },
]
